import {
    getWorkHourSettingsAPI,
    getWorkHourSettingAPI,
    createWorkHourSettingAPI,
    updateWorkHourSettingAPI,
    deactivateWorkHourSettingAPI,
    assignWorkHourSettingAPI,
    getUserWorkHourAssignmentAPI,
    getUserWorkHourAssignmentHistoryAPI,
    deleteWorkHourAssignmentAPI,
} from '../api/work-hour-settings.api'

export const getWorkHourSettings = () => {
    return (dispatch, getState) => {
        return getWorkHourSettingsAPI()
    }
}

export const getWorkHourSetting = (id) => {
    return (dispatch, getState) => {
        return getWorkHourSettingAPI(id)
    }
}

export const createWorkHourSetting = (data) => {
    return (dispatch, getState) => {
        return createWorkHourSettingAPI(data)
    }
}

export const updateWorkHourSetting = (id, data) => {
    return (dispatch, getState) => {
        return updateWorkHourSettingAPI(id, data)
    }
}

export const deactivateWorkHourSetting = (id) => {
    return (dispatch, getState) => {
        return deactivateWorkHourSettingAPI(id)
    }
}

export const assignWorkHourSetting = (data) => {
    return (dispatch, getState) => {
        return assignWorkHourSettingAPI(data)
    }
}

export const getUserWorkHourAssignment = (userId) => {
    return (dispatch, getState) => {
        return getUserWorkHourAssignmentAPI(userId)
    }
}

export const getUserWorkHourAssignmentHistory = (userId) => {
    return (dispatch, getState) => {
        return getUserWorkHourAssignmentHistoryAPI(userId)
    }
}

export const deleteWorkHourAssignment = (id) => {
    return (dispatch, getState) => {
        return deleteWorkHourAssignmentAPI(id)
    }
}
